/* eslint-disable react-hooks/exhaustive-deps */
/* รายการ Template เลือกวัสดุ */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Flex, Input, Popconfirm, Select, Space, Table, Tooltip, Typography, message } from "antd";
import { CopyOutlined, EditOutlined, PlusOutlined, SearchOutlined, StopOutlined } from "@ant-design/icons";
import StatusTag from "../../../components/ak/StatusTag";
import { TemplateService, apiError } from "../../../service/Ak.service";
import { usePermission } from "../../../store/context/permission-context";

export default function TemplateAccess() {
  const navigate = useNavigate();
  const { can } = usePermission();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState("");
  const [active, setActive] = useState("Y");

  const load = () => {
    setLoading(true);
    TemplateService.list({ q: q || undefined, active }, { ignoreLoading: true })
      .then((r) => setRows(r.data?.data || []))
      .catch((e) => message.error(apiError(e)))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [q, active]);

  const copy = (r) =>
    TemplateService.create({ copy_from: r.tpl_code })
      .then((res) => {
        message.success("คัดลอกแล้ว");
        navigate(`manage/${res.data?.data?.tpl_code}`);
      })
      .catch((e) => message.error(apiError(e)));

  const off = (r) =>
    TemplateService.remove(r.tpl_code)
      .then(() => load())
      .catch((e) => message.error(apiError(e)));

  const columns = [
    { title: "รหัส", dataIndex: "tpl_code", width: 130, render: (v) => <Typography.Link onClick={() => navigate(`manage/${v}`)}>{v}</Typography.Link> },
    { title: "ชื่อ Template", dataIndex: "tpl_name" },
    { title: "แบบบ้าน", key: "model", render: (_, r) => (r.model_code ? `${r.model_code} · ${r.model_name || ""}` : "ทุกแบบ") },
    { title: "จำนวนจุด", dataIndex: "item_count", align: "center", width: 100 },
    { title: "ใช้ไปแล้ว", dataIndex: "used_count", align: "center", width: 100, render: (v) => `${v} ใบ` },
    { title: "สถานะ", dataIndex: "active_status", width: 100, render: (v) => <StatusTag value={v} /> },
    {
      title: "",
      key: "operation",
      width: 120,
      render: (_, r) => (
        <Space size={4}>
          <Tooltip title={can("master_template", "edit") ? "แก้ไข" : "ดู"}>
            <Button size="small" icon={<EditOutlined />} onClick={() => navigate(`manage/${r.tpl_code}`)} />
          </Tooltip>
          {can("master_template", "add") && (
            <Tooltip title="คัดลอกเป็น Template ใหม่">
              <Button size="small" icon={<CopyOutlined />} onClick={() => copy(r)} />
            </Tooltip>
          )}
          {can("master_template", "delete") && r.active_status === "Y" && (
            <Popconfirm title="ปิดการใช้งาน Template นี้?" onConfirm={() => off(r)} okText="ยืนยัน" cancelText="ไม่">
              <Button size="small" danger icon={<StopOutlined />} />
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Card className="ak-card">
      <Flex justify="space-between" align="center" wrap="wrap" gap={8} className="mb-3">
        <div>
          <Typography.Title level={3} className="m-0 !text-zinc-800">
            Template เลือกวัสดุ
          </Typography.Title>
          <Typography.Text type="secondary">ชุดจุดที่ให้ลูกค้าเลือก พร้อมตัวเลือกมาตรฐาน / อัปเกรด</Typography.Text>
        </div>
        {can("master_template", "add") && (
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate("manage/new")}>
            สร้าง Template
          </Button>
        )}
      </Flex>
      <Flex gap={8} wrap="wrap" className="mb-3">
        <Input allowClear prefix={<SearchOutlined />} placeholder="ค้นหา" value={q} onChange={(e) => setQ(e.target.value)} style={{ width: 260 }} />
        <Select value={active} onChange={setActive} allowClear placeholder="สถานะทั้งหมด" style={{ width: 160 }}
          options={[{ value: "Y", label: "ใช้งานอยู่" }, { value: "N", label: "ปิดใช้งาน" }]} />
      </Flex>
      <Table rowKey="tpl_code" size="small" loading={loading} columns={columns} dataSource={rows} scroll={{ x: "max-content" }} pagination={{ pageSize: 25 }} />
    </Card>
  );
}
